import { createContext } from 'react';
import {
	ICreateModifierGroupValidationError,
	IItemForGetShortInfo,
	IServerError,
	TLanguageIDs,
	IMenuTranslation,
	IDefaultLanguage,
	ICreateModifierGroups,
	IDishesByRestaurantIdsAndSubcategoryIdsItem,
} from 'types';

export type TVisibleForm = 'mainForm' | 'translations';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'defaultTranslationIsEmpty';

export interface ICreateModifierGroupsState {
	visibleForm: TVisibleForm;
	fetchedCustomers: IItemForGetShortInfo[];
	IDSelectedCustomer: Nullable<string>;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDsSelectedRestaurant: string[];
	fetchedCategories: IItemForGetShortInfo[];
	IDsSelectedCategories: string[];
	fetchedSubcategories: IItemForGetShortInfo[];
	IDsSelectedSubcategories: string[];
	fetchedDishes: IDishesByRestaurantIdsAndSubcategoryIdsItem[];
	IDsSelectedDishes: string[];
	nameOfModifierGroup: string;
	defaultCustomerLanguage: Nullable<IDefaultLanguage>;
	selectedTranslationTab: TLanguageIDs | null;
	translations: IMenuTranslation[];
	dataForSubmit: ICreateModifierGroups | null;
	typeOfModalWindow: TTypeOfModalWindow;
	errorResponseData: IServerError<ICreateModifierGroupValidationError> | null;
}

export const createModifierGroupsInitialState: ICreateModifierGroupsState = {
	visibleForm: 'mainForm',
	fetchedCustomers: [],
	IDSelectedCustomer: null,
	fetchedRestaurants: [],
	IDsSelectedRestaurant: [],
	fetchedCategories: [],
	IDsSelectedCategories: [],
	fetchedSubcategories: [],
	IDsSelectedSubcategories: [],
	fetchedDishes: [],
	IDsSelectedDishes: [],
	nameOfModifierGroup: '',
	defaultCustomerLanguage: null,
	selectedTranslationTab: null,
	translations: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
	errorResponseData: null,
};

export interface ICreateModifierGroupsContext extends ICreateModifierGroupsState {
	changeVisibleForm(value: TVisibleForm): void;
	setFetchedCustomers(value: IItemForGetShortInfo[]): void;
	setIDCustomer(value: Nullable<string>): void;
	setFetchedRestaurants(value: IItemForGetShortInfo[]): void;
	setIDsRestaurant(value: string[]): void;
	setFetchedCategories(value: IItemForGetShortInfo[]): void;
	setIDsCategories(value: string[]): void;
	updateCategories(value: IItemForGetShortInfo[]): void;
	setFetchedSubcategories(value: IItemForGetShortInfo[]): void;
	setIDsSubcategories(value: string[]): void;
	updateSubcategories(value: IItemForGetShortInfo[]): void;
	setFetchedDishes(value: IDishesByRestaurantIdsAndSubcategoryIdsItem[]): void;
	setIDsDishes(value: string[]): void;
	updateDishes(value: IDishesByRestaurantIdsAndSubcategoryIdsItem[]): void;
	changeNameOfModifierGroup(value: string): void;
	setFetchedTranslations(value: TLanguageIDs[], defaultCustomerLanguage: Nullable<IDefaultLanguage>): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	setDataForSubmit(value: ICreateModifierGroups | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	showErrorModalWithInfo(value: IServerError<ICreateModifierGroupValidationError> | null): void;
	resetFields(): void;
}

export const CreateModifierGroupsContext = createContext<ICreateModifierGroupsContext>({
	changeVisibleForm: () => undefined,
	setFetchedCustomers: () => undefined,
	setIDCustomer: () => undefined,
	setFetchedRestaurants: () => undefined,
	setIDsRestaurant: () => undefined,
	setFetchedCategories: () => undefined,
	setIDsCategories: () => undefined,
	updateCategories: () => undefined,
	setFetchedSubcategories: () => undefined,
	setIDsSubcategories: () => undefined,
	updateSubcategories: () => undefined,
	setFetchedDishes: () => undefined,
	setIDsDishes: () => undefined,
	updateDishes: () => undefined,
	changeNameOfModifierGroup: () => undefined,
	setFetchedTranslations: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	showErrorModalWithInfo: () => undefined,
	resetFields: () => undefined,
	...createModifierGroupsInitialState,
});
